// extracted by mini-css-extract-plugin
export default {"rsl":"Testimonials_rsl__lnqSd","rsl6":"Testimonials_rsl6__O7PLy","rsl2":"Testimonials_rsl2__cfEKs","title":"Testimonials_title__gbzir","titled":"Testimonials_titled__wyIU7"};